import { createBrowserHistory } from "history";

export const myHistory = createBrowserHistory({});

export default myHistory;
